import { unitLabel, describeSkipped, skippedSummary } from './billingLabels'

/**
 * Zet de uitkomst van `computeBilling` om naar csv-rijen: dezelfde regels, het
 * totaal en wie er niet te berekenen is — precies wat de pagina toont. Geen
 * eigen berekening: alle getallen komen uit de rekenkern, en de teksten uit
 * dezelfde labelhelpers als het scherm. Een csv gaat naar een financier; hij
 * hoort niets anders te zeggen dan het scherm.
 *
 * AI-CONTEXT: See docs/pitfalls.md#ui-export-claims-everything-on-screen
 * AI-CONTEXT: See docs/pitfalls.md#ui-aggregate-collapses-nothing-into-zero
 */

const BILLING_EXPORT_HEADER = [
    'Deelnemer',
    'Traject',
    'Eenheid',
    'Soort',
    'Dagen',
    'Aantal',
    'Tarief',
    'Tariefbron',
    'Bedrag',
    'Toelichting',
]

/** Een lege rij met alle kolommen, zodat elke rij dezelfde vorm heeft. */
const emptyRow = () => Object.fromEntries(BILLING_EXPORT_HEADER.map((key) => [key, '']))

/**
 * @param {import('./computeBilling').BillingResult} result
 * @returns {Array<Record<string, string|number>>}
 */
const buildBillingExportRows = (result) => {
    const lines = result.lines.map((line) => ({
        ...emptyRow(),
        Deelnemer: line.name,
        Traject: line.routeTitle,
        Eenheid: unitLabel(line.unit),
        Soort: line.kind === 'presence' ? 'Aanwezigheid' : 'Extra regel',
        Dagen: line.kind === 'presence' ? line.days : '',
        Aantal: line.quantity,
        Tarief: line.rate,
        Tariefbron: line.tariffSource === 'route' ? 'Traject' : 'Deelnemer',
        Bedrag: line.amount,
        Toelichting: line.kind === 'adjustment' ? line.reason : '',
    }))

    const total = {
        ...emptyRow(),
        Soort: 'Totaal',
        Bedrag: result.total,
        Toelichting: skippedSummary(result.skippedPersonaCount),
    }

    const skipped = result.skipped.map((entry) => ({
        ...emptyRow(),
        Deelnemer: entry.name || 'Onbekende deelnemer',
        Soort: 'Niet te berekenen',
        Toelichting: describeSkipped(entry),
    }))

    return [...lines, total, ...skipped]
}

export default buildBillingExportRows
export { BILLING_EXPORT_HEADER }
